import PropTypes from 'prop-types';
import { memo } from 'react';
import Message from '../Message/Message';
import MessageDateTag from '../MessageDateTag/MessageDateTag';
import MessageSelectorContainer from '../MessageSelectorContainer/MessageSelectorContainer';

import NewMessageIndicator from '../NewMessageIndicator/NewMessageIndicator';
import ReadNotification from '../ReadNotification/ReadNotification';
import TypingIndicatorWrapper from '../TypingIndicatorWrapper/TypingIndicatorWrapper';

const MessageWrapper = ({ messageId }) => {
  return (
    <>
      <NewMessageIndicator messageId={messageId} />
      <MessageDateTag messageId={messageId} />
      <MessageSelectorContainer messageId={messageId}>
        <Message messageId={messageId} />
      </MessageSelectorContainer>
      <ReadNotification messageId={messageId} />
      <TypingIndicatorWrapper messageId={messageId} />
    </>
  );
};

MessageWrapper.propTypes = {
  messageId: PropTypes.string.isRequired,
};
export default memo(MessageWrapper);
